module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/promise.js
// module id = 6qwz
// module chunks = 0